import React from 'react';

const HeroGlobe = () => {
  return (
    <div className="hero-globe-viewport" aria-hidden="true">
      <div className="hero-globe-wrap">
        <div className="hero-globe-orb">
          <div className="hero-globe-texture" />
          <div className="hero-globe-shade" />
          <div className="hero-globe-highlight" />
        </div>
        <div className="hero-globe-glow" />
      </div>
    </div>
  );
};

export default HeroGlobe;
